import request from './request'

export interface CaptchaData {
  captchaId: string
  type: string
  imageBase64: string
  thumbBase64: string
  width: number
  height: number
  tileWidth: number
  tileHeight: number
  tileX: number
  tileY: number
  words?: string[]
}

export interface Point {
  x: number
  y: number
}

export interface VerifyCaptchaRequest {
  captchaId: string
  type: string
  slideX?: number
  points?: Point[]
}

export interface VerifyCaptchaResponse {
  success: boolean
}

/**
 * 获取滑动验证码
 */
export function getSlideCaptcha(): Promise<CaptchaData> {
  return request.get('/captcha?type=slide')
}

/**
 * 获取点选验证码
 */
export function getClickCaptcha(): Promise<CaptchaData> {
  return request.get('/captcha?type=click')
}

/**
 * 验证验证码
 */
export function verifyCaptcha(data: VerifyCaptchaRequest): Promise<VerifyCaptchaResponse> {
  return request.post('/captcha/verify', data)
}

export interface PublicKeyResponse {
  publicKey: string
}

/**
 * 获取 RSA 公钥
 */
export function getPublicKey(): Promise<PublicKeyResponse> {
  return request.get('/public-key')
}
